export {
  default,
  default as Paper,
  type PaperProps,
} from './Paper';
